import { useQueryClient } from "@tanstack/react-query";

import { useAdminDashboard } from "@/features/admin/hooks";
import { queryKeys } from "@/features/shared/hooks";

export const useInvalidateSelectedDashboard = () => {
  const queryClient = useQueryClient();
  const dashboard = useAdminDashboard(false);

  // Refreshes only the dashboard record (e.g. `has_unpublished_changes`).
  // Callers that also change a sub-resource (locations, elements, warnings)
  // must invalidate that sub-resource's own key themselves.
  return () => {
    if (!dashboard?.id) return;

    queryClient.invalidateQueries({
      queryKey: queryKeys.dashboardDetail(dashboard.id),
      exact: true,
    });
  };
};
